import { Locale, type LocalizedString } from "../Locale.js";
import { ProductGroup } from "../ProductGroup.js";

export const productGroupNameMap: Record<ProductGroup, LocalizedString> = {
	[ProductGroup.WarehouseAccessory]: {
		[Locale.cs]: "Vybavení skladu",
	},
	[ProductGroup.WrapingMaterials]: {
		[Locale.cs]: "Obalové materiály",
	},
	[ProductGroup.WarehouseMarking]: {
		[Locale.cs]: "Technologie",
	},
};
